
import {Link} from '@mui/material';
import {styled} from '@mui/material/styles';

import zoomPalette from 'zoomPalette';

export const ZmPrimaryLink = styled(Link)((props) => `
  color: ${props.theme.palette.primary.swatch['70']};
  background: transparent;
  &:hover {
    color: ${props.theme.palette.primary.swatch['80']};
  }
  &:active {
    color: ${props.theme.palette.primary.swatch['90']};
  }
  &.Mui-disabled {
    color: ${props.theme.palette.common.swatch['60']};
    background: transparent !important;
  }
`);

export const ZmButtonLink = styled(ZmPrimaryLink)((props) => `
font-weight: 500;
font-size: .875rem;
cursor: pointer;
color: ${zoomPalette.gray[90]}
`);
